import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  dimensionsExpandedCam: false,
  showDeactivateCompanyModal: false,
};

const setDimensionsExpandedCam = (state, payload) => ({
  ...state,
  dimensionsExpandedCam: payload.data,
});

const showHideDeactivateCompanyModal = (state, payload) => ({
  ...state,
  showDeactivateCompanyModal: payload.data,
});

export default handleActions(
  {
    [types.SET_DIMENSIONS_EXPANDED_CAM]: setDimensionsExpandedCam,
    [types.SHOW_HIDE_DEACTIVATE_COMPANY_SUCCESS_MODAL]: showHideDeactivateCompanyModal,
  },
  initialState
);
